import { supabase } from 'src/services/supabase-client';
import { WeightEntity } from '../types/weight';

export const addWeight = async (weight: WeightEntity): Promise<void> => {
  const calories = (await supabase.from('globals').select('calories').single())
    .data.calories;

  await supabase.from<WeightEntity>('weights').insert({ ...weight, calories });
};
